// Função para criar e adicionar um elemento ao head
const addToHead = (tag, attributes) => {
    const element = document.createElement(tag);
    Object.keys(attributes).forEach((key) => {
      element.setAttribute(key, attributes[key]);
    });
    document.head.appendChild(element);
    return element;
  };

  export default addToHead